import React from 'react'
import { InclusionInsightsCard } from '@diversioteam/diversio-ds'
import { Link } from 'react-router-dom'

import { withErrorBoundary } from 'config/withErrorBoundary/withErrorBoundary'
import { useInclusionInsights } from 'hooks/useInclusionInsights'

const InclusionInsightsWithoutEB = () => {
    const { data, isLoading } = useInclusionInsights()

    if (isLoading || !data || (!data.positive.length && !data.negative.length)) {
        return null
    }

    return (
        <div className="ddsi-card">
            <InclusionInsightsCard
                {...data}
                title="Inclusion Insights"
                titleWrapperProps={{
                    component: Link,
                    to: 'analyze2/inclusion/target_groups',
                }}
                actionButtonProps={{
                    component: Link,
                    to: '/goals',
                }}
            />
        </div>
    )
}

export const InclusionInsights = withErrorBoundary(InclusionInsightsWithoutEB, {})
